require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('get-prototype-descriptors')) : typeof define === 'function' && define.amd ? define(['get-prototype-descriptors'], factory) : global['memoize-getters'] = factory(global.getPrototypeDescriptors);
})(this, function (getPrototypeDescriptors) {
  'use strict';

  getPrototypeDescriptors = getPrototypeDescriptors && getPrototypeDescriptors.hasOwnProperty('default') ? getPrototypeDescriptors['default'] : getPrototypeDescriptors;
  var assign = Object.assign,
      defineProperty = Object.defineProperty;

  function memoizeClassGetters(Class) {
    var descriptors = getPrototypeDescriptors(Class);

    var _loop = function _loop(key) {
      var descriptor = descriptors[key];

      if (descriptor.get) {
        defineProperty(Class.prototype, key, assign({}, descriptor, {
          get: function memoizedGetter() {
            var value = descriptor.get.call(this);
            defineProperty(this, key, {
              value: value
            });
            return value;
          }
        }));
      }
    };

    for (var key in descriptors) {
      _loop(key);
    }

    return Class;
  }

  return memoizeClassGetters;
});